import React from 'react';
import PropTypes from 'prop-types';
import replaceCssClasses from '@src/js/Style';
import Text from '../Designer/Text';
import SkeletonText from '../Skeleton/SkeletonText';
import View from '../Designer/View';
import Scoring from './Scoring';
import Api from '../../Api';
import OfferLink from './OfferLink';

class Card extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            scoreValue: null,
            scoreLink: null,
            imageLink: null,
        };
        this.locked = false;
    }

    static get propTypes() {

        return {
            uri: PropTypes.string,
            context: PropTypes.object.isRequired,
        };
    }

    componentDidMount() {

        if (!this.locked) {

            this.locked = true;
            const uri = (this.props.uri ?? window.location.pathname).replace(/\/$/, '');
            Api
                .fetch(`/api/v2${uri}.json`)
                .then((response) => {

                    this.setState({
                        scoreValue: response.scoring.value,
                        scoreLink: response.scoring.url,
                        imageLink: response.image.url,
                    });
                });
        }
    }

    render() {

        return (
            <View className='flex flex-wrap justify-center gap size-x-220 mobile:w-full'>
                <View className='flex size-x-220'>
                    { this.renderImage() }
                </View>
                <OfferLink context={ this.props.context } />
                { this.renderScoring() }
            </View>
        );
    }

    renderImage() {

        if (this.state.imageLink === null)
            return <SkeletonText size='100%' height='138px' skeletonClassName={ replaceCssClasses('w-full h-full') } />;

        return (
            <div className='w-full' style={{ height: 138 }}>
                <img
                    alt=''
                    src={ this.state.imageLink }
                    className={ replaceCssClasses('w-full h-full object-contain') } />
            </div>
        );
    }

    renderScoring() {

        if (this.state.scoreValue === null)
            return <SkeletonText size='100%' rows={ 3 } />;

        return <Scoring
            maxWidth={ true }
            alwaysRenderDesktop={ true }
            value={ this.state.scoreValue }
            checkScoreLink={ this.state.scoreLink }
        />;
    }

}

export default Card;